export default {
  globalLoading: [],
  msgBox: {
    type: 'txt',
    msg: '',
  },
  // 当前选中的主体
  currentContractor: null,
  // 当前选中的门店
  currentShop: null,
  // 当前国家代码
  country: '',
}
